// extracted by mini-css-extract-plugin
export var readonly = "_ht-1";
export var star = "_ht-0";